import { Button } from "@material-ui/core";
import React, { useState } from "react";
import StarsIcon from "@material-ui/icons/Star";
import StarBorder from "@material-ui/icons/StarBorder";
import { prioritizeArtist } from "../../../../sdk/earnings";

interface ArtistPriorityProps {
  artistId: string;
  isPriorityArtist: boolean;
  updateRow: (isPriorityArtist: boolean) => void;
}

export const ArtistPriorityButton: React.FC<ArtistPriorityProps> = ({
  artistId,
  isPriorityArtist,
  updateRow,
}) => {
  const [loading, setLoading] = useState(false);

  const handlePriorityArtist = (artistId: string) => {
    setLoading(true);
    prioritizeArtist(artistId)
      .then((resp) => {
        updateRow(resp.isPriorityArtist);
      })
      .catch(() => {
        updateRow(!!isPriorityArtist);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <React.Fragment>
      <Button
        style={{ marginTop: "10px", paddingRight: "30px" }}
        onClick={() => handlePriorityArtist(artistId)}
        disabled={loading}
      >
        {isPriorityArtist ? <StarsIcon /> : <StarBorder />}
      </Button>
    </React.Fragment>
  );
};
